import { useState } from 'react';
import Icon from '@common/assets';
import Colors from '@domain/constant/colors';

import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface SearchProps extends HookFormProps {
  width?: number;
  height?: number;
  placeholder?: string;
  onEnter?: (keyword: string) => void;
  onChange?: (keyword: string) => void;
  onBlur?: (keyword: string) => void;
  onClear?: () => void;
}

const SearchField = ({ width, height, placeholder, onEnter, onChange, onBlur, onClear }: SearchProps) => {
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    onChange?.(newValue);
  };

  const onKeyDownInput = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const enterKye = ['NumpadEnter', 'Enter'];
    if (enterKye.includes(event.code)) {
      onEnter?.(inputValue);
    }
  };

  const handleClearBtn = () => {
    setInputValue('');
    onClear?.();
  };

  return (
    <div className={cx('searchWrap')}>
      <span className={cx('icon', 'search')}>
        <Icon name="searchLight" width={24} height={24} fill={Colors.C_COOL_GRAY_70} />
      </span>
      <input
        type="text"
        value={inputValue}
        className={cx('searchInput', { empty: !inputValue })}
        onChange={handleInputChange}
        placeholder={placeholder}
        autoComplete="off"
        onKeyDown={onKeyDownInput}
        onBlur={(e) => onBlur?.(e.target.value)}
        style={{ width, height }}
      />
      <button className={cx('icon', 'close', { isVisible: inputValue })} type="button" onClick={handleClearBtn}>
        <Icon name="closeLight" width={24} height={24} fill={Colors.C_COOL_GRAY_70} />
      </button>
    </div>
  );
};

export default SearchField;
